import { graphql } from '@/gql'

export const RejectHireMutation = graphql(/* GraphQL */ `
  mutation rejectHireMutation($input: RejectHireInput!) {
    rejectHire(input: $input) {
      id
    }
  }
`)

export const TerminateHireMutation = graphql(/* GraphQL */ `
  mutation terminateHireMutation($input: TerminateHireInput!) {
    terminateHire(input: $input) {
      id
    }
  }
`)
